import React from "react";
import { Container, Row, Col } from "reactstrap";
import "./SkeletonLoader.css";

// Generic Skeleton Pulse Component
function SkeletonPulse({ width = "100%", height = "20px", className = "" }) {
  return (
    <div
      className={`skeleton-pulse ${className}`}
      style={{
        width,
        height,
      }}
    />
  );
}

// Banner Skeleton
export function BannerSkeleton() {
  return (
    <div className="skeleton-banner" style={{ minHeight: "500px" }}>
      <SkeletonPulse height="80px" className="mb-3" />
      <SkeletonPulse height="40px" width="60%" className="mb-3" />
      <SkeletonPulse height="20px" width="80%" className="mb-2" />
      <SkeletonPulse height="20px" width="75%" />
    </div>
  );
}

// Inner Page Section Skeleton
export function InnerPageSectionSkeleton() {
  return (
    <section style={{ backgroundColor: "#eeeeee", padding: "40px 0" }}>
      <Container fluid>
        {[0, 1].map((index) => (
          <Row className="reveal-overflow align-items-center" key={index} style={{ marginBottom: "60px" }}>
            {index % 2 === 0 ? (
              <>
                <Col lg="6" className="px-0 mb-4 mb-lg-0">
                  <SkeletonPulse height="425px" />
                </Col>
                <Col lg={{ size: 4, offset: 1 }}>
                  <SkeletonPulse height="30px" width="70%" className="mb-3" />
                  <SkeletonPulse height="20px" className="mb-2" />
                  <SkeletonPulse height="20px" className="mb-2" />
                  <SkeletonPulse height="20px" width="60%" className="mb-4" />
                  <SkeletonPulse height="40px" width="120px" />
                </Col>
              </>
            ) : (
              <>
                <Col lg={{ size: 4, offset: 1 }} className="mb-4 mb-lg-0">
                  <SkeletonPulse height="30px" width="70%" className="mb-3" />
                  <SkeletonPulse height="20px" className="mb-2" />
                  <SkeletonPulse height="20px" className="mb-2" />
                  <SkeletonPulse height="20px" width="60%" className="mb-4" />
                  <SkeletonPulse height="40px" width="120px" />
                </Col>
                <Col lg={{ size: 6, offset: 1 }} className="px-0">
                  <SkeletonPulse height="425px" />
                </Col>
              </>
            )}
          </Row>
        ))}
      </Container>
    </section>
  );
}

// CSR News Skeleton
export function CSRNewsSkeleton() {
  return (
    <>
      <Container className="p-3 text-center">
        <Row>
          <Col>
            <SkeletonPulse height="40px" width="200px" style={{ margin: "0 auto" }} />
          </Col>
        </Row>
      </Container>
      <section style={{ backgroundColor: "#fafafa", padding: "40px 0" }}>
        <Container>
          {[0, 1, 2, 3, 4].map((index) => (
            <Row key={index} style={{ marginBottom: "30px" }}>
              <Col lg="6" className="mb-3 mb-lg-0">
                <SkeletonPulse height="300px" />
              </Col>
              <Col lg="6">
                <SkeletonPulse height="25px" width="80%" className="mb-3" />
                <SkeletonPulse height="20px" className="mb-2" />
                <SkeletonPulse height="20px" className="mb-2" />
                <SkeletonPulse height="20px" width="60%" />
              </Col>
            </Row>
          ))}
        </Container>
      </section>
    </>
  );
}

// Global Contact Section Skeleton
export function GlobalContactSectionSkeleton() {
  return (
    <section style={{ padding: "40px 0" }}>
      <Container>
        <Row className="text-center">
          {[0, 1].map((index) => (
            <Col md="6" lg="5" key={index} className="text-center mb-5">
              <SkeletonPulse height="60px" width="60px" style={{ margin: "0 auto", borderRadius: "50%" }} className="mb-3" />
              <SkeletonPulse height="25px" width="70%" style={{ margin: "0 auto" }} className="mb-3" />
              <SkeletonPulse height="20px" className="mb-2" />
              <SkeletonPulse height="20px" className="mb-2" />
              <SkeletonPulse height="20px" width="70%" style={{ margin: "0 auto" }} className="mb-4" />
              <SkeletonPulse height="40px" width="120px" style={{ margin: "0 auto" }} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}
